export enum TypeOriginStrategy {
  Filters = 1,
  Templates = 2,
}

export enum TypeStrategy {
  Predictive = 1,
  Progressive = 2,
  Sms = 3,
  Ivr = 4,
  Whatsapp = 5,
  Email = 6,
  IvrReturn = 7,
}

export enum TypeAssignmentStrategy {
  Aleatory = 1,
  ByAssignment = 2,
}

export enum TypePhonesStrategy {
  Landline = 1, // fijo
  Movil = 2, // movil
  Both = 3, // ambos
}

interface Portfolio {
  id: number;
  name: string;
}
interface Entity {
  id: number;
  name: string;
}

export enum TypeCoverageStrategy {
  Coverage = "true",
  UnCoverage = "false",
}

enum TemplateType {
  Image = "IMAGE",
  Video = "VIDEO",
}

export enum TypeDestinationStrategy {
  Existings = 1,
  External = 2,
}

interface TemplateWhatsapp {
  template_id: string;
  template: string;
  template_media: string;
  template_type: TemplateType;
  associate: string;
}

interface FilterClientValue {
  id: number;
  name: string;
}
interface FilterCustomClientValue {
  name: string;
  title: string;
  type: "decimal" | "text";
  values: string[];
}

interface FilterClient {
  name: string;
  type: string;
  value?: string | number;
  values?: FilterClientValue[] | string[];
}

export interface DataSourceStrategy {
  id: number;
  type_strategy_name: string;
  destination?: TypeDestinationStrategy;
  portfolio: Portfolio;
  entity: Entity;
  type_assignment?: TypeAssignmentStrategy;
  queue?: string;
  template_whatsapp?: TemplateWhatsapp;
  type_phone?: TypePhonesStrategy;
  coverage: boolean;
  filters?: {
    clients?: FilterClient[];
    custom_clients: FilterCustomClientValue[];
    custom_products: FilterCustomClientValue[];
  };
  type_strategy: number;
  execution_time?: any;
  message_preview?: string;
  subject?: string;
  email_config?: EmailInformation;
  template_email?: TemplateEmail;
}

export interface ItemSecondSection {
  label?: string;
  value: string | string[];
}

export interface EmailInformation {
  alias: string;
  from_email: string;
}
export interface TemplateEmail {
  name: string;
  template: string;
  template_id: string;
}

export enum AudioConfigType {
  Upload = "upload",
  Tts = "tts",
}

export enum TtsProvider {
  Google = "google",
}

export enum TtsModel {
  Wavenet = "wavenet",
}

export enum TtsVoiceType {
  Male = "male",
  Female = "female",
}